import { submit } from 'redux-form';

export default formName => dispatch => {
  dispatch(submit(formName));
};
